import { Injectable, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzI18nService, en_US, es_ES } from 'ng-zorro-antd/i18n';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private translate = inject(TranslateService);
  private i18n = inject(NzI18nService);

  currentLanguage = signal<string>('es');

  async init() {
    this.translate.addLangs(['en', 'es']);
    this.translate.setDefaultLang('es');

    let langToUse = localStorage.getItem('language');

    if (!langToUse) {
      const browserCultureLang = this.translate.getBrowserCultureLang();
      langToUse = 'es';

      if (browserCultureLang) {
        if (browserCultureLang.match(/^en/)) {
          langToUse = 'en';
        } else if (browserCultureLang.match(/^es/)) {
          langToUse = 'es';
        }
      }
    }

    await this.changeLanguage(langToUse);
  }

  async changeLanguage(lang: string) {
    if (lang === 'en') {
      this.i18n.setLocale(en_US);
    } else {
      this.i18n.setLocale(es_ES);
    }
    localStorage.setItem('language', lang);
    this.currentLanguage.set(lang);
    return firstValueFrom(this.translate.use(lang));
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang;
  }

  instant(key: string, options?: Object): string {
    return this.translate.instant(key, options);
  }
}
